import React from 'react'
import LoginCom from '../Components/Login/LoginCom'

const Login = () => {
  return (
    <div>
      <LoginCom />
    </div>
  )
}

export default Login